import { createFileRoute } from "@tanstack/react-router";
import { FunilCursoPage } from "@/components/funis/FunilCursoPage";
import { FUNIS } from "@/lib/funis/config";

const cfg = FUNIS["funil-tmanual"];

export const Route = createFileRoute("/funil-tmanual")({
  head: () => ({
    meta: [
      { title: "Curso Gratuito: Terapia Manual Ortopédica" },
      { name: "description", content: "Curso online e gratuito de Terapia Manual Ortopédica aplicada aos MMSS, MMII e Coluna Vertebral. Certificado de 5h, baseado em evidências." },
      { property: "og:title", content: "Curso Gratuito: Terapia Manual Ortopédica" },
      { property: "og:description", content: "Avaliação clínica, terapia manual e tomada de decisão. Curso 100% gratuito, online, com certificado." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://fisioemortopedia.com.br/funil-tmanual" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Curso Gratuito: Terapia Manual Ortopédica" },
      { name: "twitter:description", content: "Curso 100% gratuito, online, com certificado de 5h." },
    ],
    links: [{ rel: "canonical", href: "https://fisioemortopedia.com.br/funil-tmanual" }],
  }),
  component: () => <FunilCursoPage cfg={cfg} />,
});
